import PropTypes from 'prop-types';
import { SearchBadge } from '../../assets/images';
import ImageComponent from '../WebChat/Common/ImageComponent';

const ParticipantsBadge = props => {
    const { jid, userToken, image, thumbImage, contactName } = props;

    const handleRemoveParticipant = () => {
        return props.removeParticipant(jid);
    };

    return (
        <li>
            <div>
                <span className="badgeImg">
                    <ImageComponent
                        userToken={userToken}
                        imageToken={thumbImage && thumbImage !== '' ? thumbImage : image}
                        temporary={true}
                        chatType="chat"
                    />
                </span>
                <span title={contactName} className="badgeTitle">
                    {contactName}
                </span>
                <i
                    className="badgeAction"
                    onClick={() => handleRemoveParticipant()}
                    onKeyDown={e => e.key === 'Enter' && handleRemoveParticipant()}
                    tabIndex="0"
                    role="button"
                >
                    <SearchBadge />
                </i>
            </div>
        </li>
    );
};

export default ParticipantsBadge;

ParticipantsBadge.propTypes = {
    jid: PropTypes.string,
    userToken: PropTypes.string,
    image: PropTypes.string,
    thumbImage: PropTypes.string,
    contactName: PropTypes.string,
    removeParticipant: PropTypes.func,
};
